var _path, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2001,
    height: 465,
    viewBox: "0 0 2001 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M996.1 18.7108C977.789 46.4132 736.078 401.259 368.828 401.259C340.451 401.26 47.7825 401.259 25.8324 401.259C25.0385 401.259 24.5312 401.903 24.5312 402.697V463.133C24.5312 463.926 25.1749 464.57 25.9688 464.57H1969.47C1970.26 464.57 1970.91 463.926 1970.91 463.133V402.697C1970.91 401.903 1970.39 401.26 1969.6 401.26H1625.61C1251.42 401.26 1016.18 46.5295 998.314 18.7244C997.743 17.8354 996.682 17.8292 996.1 18.7108Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 424.109H373.395C752.811 424.109 997.26 42.606 997.26 42.606C997.26 42.606 1234.47 424.11 1621.13 424.11H1968.51",
    stroke: "url(#paint0_linear_36_434)",
    strokeWidth: 13.4167
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.869 428.17C740.662 428.17 978.149 87.0416 996.23 60.2716C996.815 59.406 997.856 59.4122 998.429 60.2854C1016.07 87.1583 1247.2 428.17 1614.81 428.17",
    stroke: "url(#paint1_linear_36_434)",
    strokeWidth: 0.479167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M381.012 430.759C741.132 430.759 978.181 90.2206 996.245 63.473C996.829 62.6072 997.87 62.6134 998.444 63.4867C1016.07 90.337 1246.77 430.759 1613.7 430.759",
    stroke: "url(#paint2_linear_36_434)",
    strokeWidth: 0.670833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7617 438.092H383.678C742.232 438.092 978.259 99.2104 996.279 72.5404C996.864 71.675 997.904 71.6812 998.478 72.5542C1016.06 99.3268 1245.77 438.093 1611.1 438.093H1969.23",
    stroke: "url(#paint3_linear_36_434)",
    strokeWidth: 0.670833
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36_434",
    x: 0.09375,
    y: 0.330241,
    width: 2000.04,
    height: 464.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.91667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.8125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_434",
    x1: 607.677,
    y1: 2036.4,
    x2: 2136.78,
    y2: 2341.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_434",
    x1: 1005.15,
    y1: 58.6094,
    x2: 1005.15,
    y2: 3921.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36_434",
    x1: 1005.15,
    y1: 61.8105,
    x2: 1005.15,
    y2: 3918.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36_434",
    x1: 1005.15,
    y1: 70.8794,
    x2: 1005.15,
    y2: 3909.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSm);
export default __webpack_public_path__ + "static/media/bg-sm.27da3313b0bf2f518c291939d4b38772.svg";
export { ForwardRef as ReactComponent };